import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import { Typography, Grid } from '@material-ui/core';
import { TextLink } from '@ds/react-components';
import ContactDialog from 'common/dialogs/ContactDialog';

const styles = (theme) => ({
  root: {
    backgroundColor: '#ffffff',
    minHeight: '80px',
    top: 'auto',
    bottom: 0,
    position: 'fixed',
    width: '100%',
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      position: 'relative',
    },
    display: 'flex',
    fontSize: 12,
    alignItems: 'center',
  },
  footerContent: {
    width: '80%',
    marginLeft: 'auto',
    marginRight: 'auto',
    '& p': {
      color: theme.palette.common.lightText,
      fontSize: '12px',
      textAlign: 'right',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
        paddingTop: 12,
        paddingBottom: 12,
      },
    },
    '& p$copyright': {
      textAlign: 'left',
      [theme.breakpoints.down('sm')]: {
        textAlign: 'center',
      },
    },
  },
  copyright: {},
});
class Footer extends React.PureComponent {
  render() {
    const { classes } = this.props;

    return (
      <div className={classes.root}>
        <Grid
          container
          className={classes.footerContent}
          alignContent="center"
          justify="center">
          <Grid item xs={12} md={7}>
            <Typography className={classes.copyright}>
              © {new Date().getFullYear()} Debitsuccess
            </Typography>
          </Grid>
          <Grid item xs={12} md={3}>
            <Typography>
              <TextLink to="/Terms">Terms and Conditions</TextLink>
            </Typography>
          </Grid>
          <Grid item xs={12} md={1}>
            <Typography>
              <TextLink
                to="#"
                onClick={() => {
                  window.open(
                    'https://debitsuccess.atlassian.net/wiki/spaces/DP/overview',
                    '_blank'
                  );
                  return false;
                }}>
                Help
              </TextLink>
            </Typography>
          </Grid>
          <Grid item xs={12} md={1}>
            <Typography>
              <ContactDialog linkText="Contact Us" />
            </Typography>
          </Grid>
        </Grid>
      </div>
    );
  }
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles, { withTheme: true })(Footer);
